import {
  showFinishCardContentAndSection,
} from './case_experience_in_rails';
import { hideRailsuiModal, showRailsuiModal } from '../railsui_modal';
import { caseViewerDocumentId, createModalPendingStorage } from './modal_pending_storage';

const CASE_COMPLETION_MODAL_ID = 'case-completion-modal';
const LOW_TIME_MODAL_ID = 'low-time-new-modal';
const STORAGE_KEY_PREFIX = 'case-experience:caseCompletionModalPending:';

/** Sync claim so concurrent Finish Case connects restore at most once per document. */
const restoreClaims = new Set();

const caseCompletionModalPending = createModalPendingStorage(STORAGE_KEY_PREFIX);

export { caseViewerDocumentId };

export function caseCompletionModalRoot() {
  return document.getElementById(CASE_COMPLETION_MODAL_ID);
}

export async function showCaseCompletionModal() {
  return showRailsuiModal(caseCompletionModalRoot(), { disableEscape: true });
}

export function hideCaseCompletionModal() {
  hideRailsuiModal(caseCompletionModalRoot());
}

/** Namespaced per document so concurrent cases do not collide. */
export const caseCompletionModalPendingStorageKey = caseCompletionModalPending.storageKey;

export const isCaseCompletionModalPending = caseCompletionModalPending.isPending;

/**
 * Client-only UI flag so case-completion modal survives refresh.
 * Not shared across devices/sessions — set true before open, remove on complete/reset.
 */
export const persistCaseCompletionModalPending = caseCompletionModalPending.persist;

/** Reopen via Aquifer UI modal lifecycle when localStorage still has pending=true. */
export async function restoreCaseCompletionModalIfPending(showFn = showCaseCompletionModal) {
  const documentId = caseViewerDocumentId();
  if (documentId == null || !isCaseCompletionModalPending(documentId)) return false;
  if (restoreClaims.has(documentId)) return false;
  restoreClaims.add(documentId);

  hideRailsuiModal(document.getElementById(LOW_TIME_MODAL_ID));
  const opened = await showFn();
  if (!opened) {
    persistCaseCompletionModalPending(false, documentId);
    restoreClaims.delete(documentId);
    await showFinishCardContentAndSection();
  }
  return opened;
}

/** Test-only: clear in-page restore claims between examples. */
export function resetCaseCompletionModalRestoreClaimsForTests() {
  restoreClaims.clear();
}
